import React from 'react';
import PropTypes from 'prop-types';
import RpTable, { Loading } from 'rp-react-table';
import { capitalize, toLower, uniq } from 'lodash';
import Filter from 'rp-react-common/Filter';

import columns from './columns';
import { categoriesFactory } from './categories';
import categoriesReducer from './reducer';
import FilteringComponent from '../../shared/filter';
import { selection } from '../../utils/filter';

const dataKeys = ['topJockeys', 'topTrainers', 'topHorses', 'topOwners'];

class Stats extends FilteringComponent {
    constructor(props) {
        super(props);

        this.dataKey = 'statistics';
        this.emptyData = {};
        this.tab = 'stats';

        const {
            profile: { courseTypeCode, courseCountryCode },
            seasonInfo: { raceType },
            statistics,
            seasonsAvailable,
        } = props.data;

        const categories = categoriesFactory(
            courseTypeCode, courseCountryCode, raceType, seasonsAvailable
        );

        this.state = {
            data: statistics || this.emptyData,
            categories,
            fetchError: false,
        };
    }

    renderStatus() {
        const { categories } = this.state;
        const raceType = selection.getCaption(categories, 'raceType');

        const { value, label } = selection.getOption(categories, 'timePeriod');

        if (value.match(/last5/)) {
            return <h2 className="ui-filter__statusText">{raceType}, {toLower(label)}</h2>;
        }

        const years = uniq(value.split('/').slice(0, 2));
        if (years.length > 1) {
            years[1] = years[1].slice(2);
        }
        return <h2 className="ui-filter__statusText">{raceType}, {years.join('-')}</h2>;
    }

    renderDefaultStatus() {
        const {
            raceType, seasonYearBegin, seasonYearEnd,
        } = this.props.data.stats.seasonInfo;
        const years = seasonYearBegin === seasonYearEnd ?
            seasonYearBegin : `${seasonYearBegin}-${seasonYearEnd}`;

        return (
            <h2 className="ui-filter__statusText">
                {capitalize(raceType)}, {years}
            </h2>
        );
    }

    render() {
        const { loading, data, categories, fetchError } = this.state;

        return (
            <section className="cp-stats">
                <Filter
                    categories={categories}
                    categoriesReducer={categoriesReducer}
                    fetchError={fetchError}
                    onFilterApply={this.onFilterApply}
                />
                {!fetchError && (!loading ? (
                    <div className="cp-stats__tablesWrapper">
                        {dataKeys.map(dataKey => (
                            <RpTable
                                key={dataKey}
                                data={data[dataKey]}
                                columns={columns[dataKey]}
                                noDataText="No stats found"
                                className={`cp-stats__table_${
                                    dataKey === 'topHorses' ? 'horse' : 'human'
                                    }`}
                            />
                        ))}
                    </div>
                ) : (
                    <Loading />
                ))}
            </section>
        );
    }
}

const genericRow = {
    wins: PropTypes.number,
    runs: PropTypes.number,
    stake: PropTypes.number,
    styleName: PropTypes.string,
    winPercent: PropTypes.number,
};

Stats.propTypes = {
    data: PropTypes.shape({
        seasonInfo: PropTypes.shape({
            seasonYearBegin: PropTypes.number,
            seasonYearEnd: PropTypes.number,
            raceType: PropTypes.string,
        }),
        stats: PropTypes.shape({
            statistics: PropTypes.shape({
                topJockeys: PropTypes.arrayOf(PropTypes.shape(genericRow)),
                topTrainers: PropTypes.arrayOf(PropTypes.shape(genericRow)),
                topHorses: PropTypes.arrayOf(PropTypes.shape({
                    ...genericRow,
                    trainerName: PropTypes.string,
                    topRpr: PropTypes.number,
                })),
                topOwners: PropTypes.arrayOf(PropTypes.shape(genericRow)),
            }),
        }),
        profile: PropTypes.shape({
            courseCountryCode: PropTypes.string,
        }),
    }),
    params: PropTypes.shape({
        id: PropTypes.string,
    }),
};

export default Stats;



// WEBPACK FOOTER //
// ./src/js/course/stats/Stats.jsx